
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.147 6.437a.882.882 0 01.882-.878h26.03c.487 0 .882.395.882.882V23.56a.882.882 0 01-.882.882H1.94a.882.882 0 01-.882-.887l.088-17.117zm1.76.887l-.08 15.352h24.35V7.325H2.906z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.677 13.059c0-.487.395-.882.882-.882h5.912a.882.882 0 110 1.764h-5.912a.882.882 0 01-.882-.882z","fill":"#fff"}}),_c('path',{attrs:{"d":"M10.059 10.853l1.412 2.735 3 .441-2.206 2.118.53 3-2.736-1.412-2.647 1.412.53-3-2.207-2.118 3-.44 1.324-2.736z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.677 16.941c0-.487.395-.882.882-.882h5.912a.882.882 0 010 1.764h-5.912a.882.882 0 01-.882-.882z","fill":"#fff"}})])
          )
        }
      }
    